exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-default[data-v-7ab96fe0] {\n  margin-right: .2rem;\n  display: inline-block !important;\n}\n", ""]);

// exports
